import { render, staticRenderFns } from "./NavTest.vue?vue&type=template&id=4c2fba60&"
import script from "./NavTest.vue?vue&type=script&lang=js&"
export * from "./NavTest.vue?vue&type=script&lang=js&"
import style0 from "./NavTest.vue?vue&type=style&index=0&id=4c2fba60&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports